import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Menu } from 'antd';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import history from '../../../../history/history';
import {
  NavMenu,
  NavContainer,
  NavMenuItem,
  NavSubMenuItem,
  NavInline,
  Img,
  ImageContainer,
  HamBurger,
  DisplayFlexContainer,
  AssistanceContainer,
  NavMenuItem123,
  MainPagesNavigation,
  NavSubMenu
} from './style';
import { FixedWidth } from '../../../commonStyles';
import {
  menuConfig,
  faConfig,
  menuNames
} from './config';
import { showAssistanceComponent } from '../NeedAssistance/action';
import logo from '../../../../assets/icons/vcep-logo.svg';
import hamburger from '../../../../assets/icons/hamburger.svg';
import close from '../../../../assets/icons/close.svg';
import {
  getPrimaryAccount,
  getAccountData,
  isGeminiUser,
  getTokenInfo
} from '../../../../utils/sessionUtil';
import { getpwUrl, initiateTracking, recordError,getBaseUrl,isAllShareAllPool  } from '../../../../utils/commonUtil';
import { availableBalance, selectHeader } from '../../../../actions/globalActions';
import { getFreezeFeaturesList } from '../../../../utils/freezeUtil';
import HoverText from '../../../Info/Tooltip/HeaderTooltip';
import { isReadOnlyWithExchangeRole } from '../../../../Epics/Investments/Pages/RecommendAnExchangeNew/util'
import { PagesNavDerivedStates } from '../../selectors';
const advisorResourcesLocation = `${getBaseUrl()}/advisors`;

class PagesNav extends Component {
  state = {
    mode: 'horizontal',
    isOpen: false,
    current: '',
    access: 'All Access',
    availableBalance: ''
  };
  counterChecker = 0;
  freezeMessage =
            'Transactions for this account are frozen. Contact us at 888-383-4483 or donorservice@vanguardcharitable.org.';

  // Check enitity is organization
  checkOrganizationEntity = () => {
    const { navBarData } = this.props;
    return isGeminiUser() && navBarData && navBarData.entityType.toLowerCase() === 'organization';
  }

  // check the user is web registered or not 
  checkWebAccess = navBarData => navBarData && navBarData.webAccess;

  //check no access level
  checkNoAccess = navBarData => navBarData && navBarData.accessLevel === 'No Access';

  // check primaryAccountDonor only
  checkIsPrimaryAccounDonorOnly = navBarData => navBarData && navBarData.isPrimaryAccountDonorOnly;
  
  checkDisableMenuItemsForCSR = (menuItem) => {
    const { navBarData } = this.props;
    switch(menuItem) {
      case 'MY ACCOUNT':
        return !this.checkWebAccess(navBarData) && this.checkIsPrimaryAccounDonorOnly(navBarData);
      case 'PROFILE':
        return (!this.checkWebAccess(navBarData) && this.checkIsPrimaryAccounDonorOnly(navBarData)) || this.checkOrganizationEntity();
      default: return false;  
    }
  }

  componentWillMount() {
    this.props.getAvailableBalance({
      metaData: [
        {
          method: 'GET',
          url: `/donor-portal/api/account/${
            getPrimaryAccount().userId
            }/findBalance`
        }
      ]
    });
  }

  componentDidMount() {   
    this.setState({ access: getPrimaryAccount().role.access }, () => {
      this.checkForCurrentRoute(this.props.location.pathname);
    });
  }

  checkForCurrentRoute(currentLink) {
    const link = currentLink.trim();
    switch (link) {
      case '':
      case '/':
        this.setState({ current: 'ACCOUNT SUMMARY' });
        break;
      case '/financialadvisor':
        this.setState({ current: 'DASHBOARD' });
        break;
      case '/grants':
      case '/grants/recommend':
      case '/grants/agreement':
      case '/grants/grant-agreement':
      case '/grants/grant-agreement/charity-purpose':
      case '/grants/grant-agreement/allocation-schedule':
      case '/grants/activity':
      case '/grants/how-it-works':
      case '/grants/activity/view':
        this.setState({ current: 'Grants_Header' });
        break;
      case '/contributions':
      case '/contributions/make-a-contribution':
      case '/contributions/activity':
        this.setState({ current: 'Contributions_Header' });
        break;
      case '/investments':
      case '/view-edit-tiff-from/:id/view':
      case '/view-edit-tiff-into/:id/view':
      case '/investments/recommend-an-exchange/:id/':
        this.setState({ current: 'Investment_Header' });
        break;
      case '/investments/exchange-activity':
      case '/investments/details':
      case '/investments/recommend-an-exchange':
      case '/investments/recommend-an-exchange/:id/':
        this.setState({ current: 'Investment option details' });
        break;
      case '/my-account':
      case '/my-account/my-documents':
      case '/my-account/transaction-summary':
        this.setState({ current: 'My_Account_Header' });
        break;
      default:
        this.setState({ current: 'N/A' });
        break;
    }
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.availableBalance) {
      this.setState({ availableBalance: nextprops.availableBalance });
    }

    if(this.counterChecker !== 0){
      this.setState({
        current: nextprops.selected
      });
    }
    this.counterChecker++;

    if (!nextprops.isToggle) {
      this.setState({
        isOpen: false
      });
    }

    if (this.props.accountID !== nextprops.accountId) {
      this.setState({ access: getPrimaryAccount().role.access }, () => {
        if (this.props.location.pathname === '/') {
          this.setState({ current: 'ACCOUNT SUMMARY' });
        }
      });
    }
  }
  
  handleClick = e => {
    try {
      this.setState({
        current: e.key
      });
    } catch (error) {
      recordError(error);
    }
  };

  toTitleCase(str) {
    return str.replace(/\w\S*/g, txt => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  goToRoute(link, linkName, sourceValue = '', menuParentName = '') {
    if(linkName === 'ADVISOR RESOURCES') {
      window.open(advisorResourcesLocation,'_blank');
      return;
    }
    if(menuParentName !== ''){
      initiateTracking('globalNavigationDP', 'Navigation', 'Global Header Navigation DP', menuParentName + ' - ' + this.toTitleCase(linkName));
    }else{
      initiateTracking('globalNavigationDP', 'Navigation',  'Global Header Navigation DP', linkName);
    }
    this.props.selectedHeader(linkName);
    this.setState({ isOpen: false }, () => {
      if(typeof sourceValue === 'string'){
        history.push({ pathname: link, state: { fromMenu: true, source: sourceValue } });
      }else{
        history.push({ pathname: link, state: { fromMenu: true } });
      }
    });
  }

  goToHomeRoute(key, link) {
    this.setState(
      {
        isOpen: false,
        current: key
      },
      () => {
        history.push(link);
      }
    );
  }

  renderSubMenu = menu => (
    <NavSubMenuItem
      disabled={this.checkDisableMenuItemsForCSR(menu.name)}
      key={menu.name}
      className={ menu.name === 'CSR' ? 'geminiColor' : "" }
      title={
        <NavMenuItem123
          disabled={this.checkDisableMenuItemsForCSR(menu.name)}
          key={menu.name}
          href='javascript:void(0)'
          onClick={() => menu.link ? this.goToRoute(menu.link, menu.name) : null}
        >
          <span className='submenu-title-wrapper'>{menu.name}</span>
        </NavMenuItem123>
      }
    >
      {menu.childNode.map((node) => {
        return menu.name !== 'CSR' ? this.checkingForDifferentSubMenu(node, menu.name) : this.populateCSRSubmenus(node)
        }
      )}
    </NavSubMenuItem>
  );

  renderMenu = menu => {
    return (
      <NavMenuItem key={menu.name}>
        {menu.className === 'tool-tip' ? (
          <NavMenuItem123
            href='javascript:void(0)'
            className={menu.className}
          >
            {menu.name}
            <span class='tooltiptext header-tp-position-bottom dynamic-tooltip'>
              Coming Soon...
            </span>
          </NavMenuItem123>
        ) : (
            <NavMenuItem123
              href='javascript:void(0)'
              onClick={() => {
                try {
                  this.goToRoute(menu.link, menu.name);
                } catch (error) {
                  recordError(error);
                }
              }}
            >
              {menu.name}
            </NavMenuItem123>
          )}
      </NavMenuItem>
    );
  };

  renderNavMenu = menu => {
    switch (menu.childNode.length > 0) {
      case true:
        return this.renderSubMenu(menu);
      case false:
        return this.renderMenu(menu);
      default:
        break;
    }
  };

  openDrawer = () => {
    try {
      this.setState(
        {
          mode: 'inline',
          isOpen: !this.state.isOpen
        },
        () => {
          if (!this.state.isOpen) {
            document.querySelector('body').style.overflow = '';
            document.querySelector('body').style.height = '';
          }
        }
      );
    } catch (error) {
      recordError(error);
    }
  };

  changeHeaderSelection(key, link) {
    this.setState({ current: key }, () => {
      history.push(link);
    });    
    getTokenInfo();    
  }

  renderNavigation = pathName => {
    const financialAdvisorFlag = JSON.parse(sessionStorage.getItem('userData'));
    let renderer = true;
    switch (pathName) {
      case 'DASHBOARD':
        if (financialAdvisorFlag.financialAdvisorForAnyAccount) {
          renderer = true;
        } else {
          renderer = false;
        }
        break;
      case 'RESOURCES':
        if (financialAdvisorFlag.financialAdvisorForAnyAccount) {
          renderer = false;
        } else {
          renderer = true;
        }
        break;
      case 'CSR':
        renderer = isGeminiUser();
        break;
      default:
        renderer = true;
    }
    return renderer;
  };

  getHoverMessageWhenDisabled(partyFreeze, access) {
    let msg = '';
    if (this.state.availableBalance === '0') {
      msg = 'Available Balance is 0';
    }
    if (access === 'Read Only') {
      msg = 'User has only read-only access';
    }
    if (partyFreeze && partyFreeze.length !== 0) {
      msg = partyFreeze[0];
    }
    return msg;
  }

  // Updated Pages Nav Condition For Disabled / Comming Soon / Hidden
  renderNavigationSubMenu(node, title = '') {
    const primaryAccount = getPrimaryAccount();
    const userData = getAccountData();
    const { partyFreezes } = userData;
    if (
      primaryAccount.role.access === 'Read Only' ||
      this.state.availableBalance === 0 ||
      (partyFreezes && partyFreezes.length !== 0)
    ) {
      return (
        <Menu.Item
          key={node.name}
          title={this.getHoverMessageWhenDisabled(
            partyFreezes,
            primaryAccount.role.access
          )}
          disabled
          className={node.className}
        >
          <NavLink to={node.link}>{node.name}</NavLink>
        </Menu.Item>
      );
    } else {
      return (
        <Menu.Item key={node.name} className={node.className}>
          <NavLink to={node.link}>{node.name}</NavLink>
        </Menu.Item>
      );
    }
  }

  makeAContribution(node, menuParentName) {
    const currentSource =
      this.props.location.state && this.props.location.state.source;
    let sourceValue = 'header';
    if (currentSource && currentSource === 'header') {
      sourceValue = 'headerReload';
    }
    return (
      <Menu.Item key={node.name} className={node.className}>
        <a
          href='javascript:void(0)'
          onClick={() => {
            try {
              this.goToRoute(node.link, node.name, sourceValue, menuParentName);
            } catch (error) {
              recordError(error);
            }
          }}
        >
          {node.name}
        </a>
      </Menu.Item>
    );
  }

  makeTheMenuDisabled = (node, msg) => {
    return (
        <NavMenuItem
        key={node.name}
        disabled
        className={node.className}
      >
        <HoverText 
          mobile={window.screen.availWidth <= 991 ? true : false}
          mobilePlacement='bottomLeft'
          placement='rightTop' 
          title={msg} 
          overlayClassName='disabled-header'>
          <a
            href='javascript:void(0)'
            disabled
          >
            {node.name}
          </a>
        </HoverText>
      </NavMenuItem>
    );
  };

  getReadOnlyText(node) {
    let redOnlyText = '';
    switch (node.name) {
      case 'Recommend an exchange':
        redOnlyText = 'exchanges';
        break;
      case 'Recommend a grant':
        redOnlyText = 'grants';
        break;
      case 'Make a contribution':
        redOnlyText = 'contributions';
        break;
    }
    redOnlyText = `You are unable to recommend ${redOnlyText} on this account. If you believe this is an error, please contact us at 888-383-4483.`;
    return {
      type: 'Access',
      node: node,
      msg: redOnlyText
    };
  }

  getAvailableBalanceText(node) {
    let availableBalanceText = '';
    switch (node.name) {
      case 'Recommend a grant':
        availableBalanceText = 'Grant';
        break;
      case 'Recommend an exchange':
        availableBalanceText = 'Exchange';
        break;
    }
    availableBalanceText = `This account has $0.00 available balance. ${availableBalanceText} Transaction cannot continue.`;
    return {
      type: 'Balance',
      node: node,
      msg: availableBalanceText
    };
  }

  getAllShareAllPoolStatusMessage(node) {
    let allShareAllPoolTag = '';
    switch (node.name) {
      case 'Recommend a grant':
        allShareAllPoolTag = 'Additional grant transactions';
        break;
      case 'Grant Agreements':
          allShareAllPoolTag = 'Additional grant transactions';
          break;
      case 'Recommend an exchange':
        allShareAllPoolTag = 'Exchanges';
        break;
    }
    allShareAllPoolTag = `A grant has been recommended to close the account. ${allShareAllPoolTag} cannot be submitted.`;
    return {
      type: 'Balance',
      node: node,
      msg: allShareAllPoolTag
    };
  }

  checkForFreezeFunctionality(node, partyFreezes, freezes) {
    const finalBlockList = getFreezeFeaturesList(partyFreezes, freezes);
    if (finalBlockList && finalBlockList.length) {
      const output = finalBlockList.filter(menu => {
        if (menuNames[menu] === node.name) {
          return node.name;
        }
      });
      return output;
    }
  }

  checkDisableMenuItems(menuItem){
    return _.indexOf(['Recommend an exchange', 'Recommend a grant', 'Make a contribution'], menuItem) > -1;
  }

  validateItemAccess(objForChecking, makeAContributionFlag, csrOnly) {
    const {
      role,
      node,
      partyFreezes,
      freezes,
      availableBalance,
    } = objForChecking;
    let featureFrozen = [];
    if(isGeminiUser() && csrOnly) { return this.validateItemAccessForCsr(objForChecking, node);}
    if(!isGeminiUser() && csrOnly) return false;
    if (((partyFreezes && partyFreezes.length) || (freezes && freezes.length))) {
      featureFrozen = this.checkForFreezeFunctionality(node, partyFreezes, freezes);
      if (featureFrozen.length) {
        return featureFrozen;
      }
    }
    let isAllShareAllPoolStatus = isAllShareAllPool();
    if (availableBalance === 0  && !makeAContributionFlag) {
      return this.getAvailableBalanceText(node);
    }else if (isAllShareAllPoolStatus && !makeAContributionFlag) {
      return this.getAllShareAllPoolStatusMessage(node);
  }
    if (role.access === 'Read Only') {
      return (node.name === "Recommend an exchange" && isReadOnlyWithExchangeRole()) ? false : this.getReadOnlyText(node);
    }
    if(isGeminiUser() && this.checkDisableMenuItems(node.name)) { return this.validateItemAccessForCsr(objForChecking, node)}
    return false;
  }

  displayCheck(objForChecking, node, menuParentName, makeAContributionFlag, csrOnly=false) {
    const status = this.validateItemAccess(objForChecking, makeAContributionFlag, csrOnly);
    if (!status.length && status.type !== 'Access' && status.type !== 'Balance') {
      if (makeAContributionFlag) {
        return this.makeAContribution(node, menuParentName);         
      }
      return this.renderNavMenuItem(node, menuParentName);
    }else if (status.type === 'Access' || status.type === 'Balance') {
      return this.makeTheMenuDisabled(node, status.msg);
    } else{
      return this.makeTheMenuDisabled(node, this.freezeMessage);
    }
  }

  // CSR User Only
  validateItemAccessForCsr(objForChecking, node) {    
    if(!isGeminiUser()) return false;
    const { accountRole } = objForChecking;
    const { navBarData } = this.props;
    let message =  '';
    let disabled = false;
    switch(accountRole){
      case 'Donor': message = 'Donors without account access cannot view this page.';
        disabled = true; 
        break;
      case 'Trusted Advisor':
      case 'Designated Party':
        if(node.name === 'Account Details') return false;
        if(!this.checkNoAccess(navBarData)) return false;
        message = 'Interested parties with no access to the account cannot view this page.';
        disabled = true
        break;
    }
    return disabled ? { type: 'Access', node: node, msg: message } : false;
  }

  populateCSRSubmenus(node) {
    return (
      <Menu.Item key={node.name} className={node.className}>
        <a onClick={() => {
          try {
            window.location.replace(`${process.env.REACT_APP_GEMINI_CSR_URL}/vceptpl/csr/${node.link}?dafAccountId=${getPrimaryAccount().userId}`);
          } catch (error) {
            recordError(error);
          }
        }}
        >{node.name}</a>
      </Menu.Item>
    );
  }

  checkingForDifferentSubMenu(node, menuParentName) {
    const userData = getAccountData();
    const primaryAccount = getPrimaryAccount();
    const { partyFreezes } = userData;
    const { freezes } = primaryAccount;

    const { grantAgreementFlag, availableBalance, accountRole } = this.props;
    const { role } = primaryAccount;
    const objForChecking = {
      role,
      node,
      partyFreezes,
      freezes,
      availableBalance,
      accountRole
    };
    
    switch (node.name) {
      case 'Recommend a grant':
        return this.displayCheck(objForChecking, node, menuParentName);
      case 'Recommend an exchange':
        return this.displayCheck(objForChecking, node, menuParentName);
      case 'Make a contribution':
        return this.displayCheck(objForChecking, node, menuParentName, true);
      case 'Grant Agreements':
        // We Will Need this code when Grant Agreement Will Be Pushed
        if (grantAgreementFlag) {
          return this.displayCheck(objForChecking, node);
        } else {
          return null;
        }
      case 'Investment Overview':
      case 'Exchange Activity':
      case 'Investment option details':
      case 'Grant Overview':
      case 'Grant Activity':
      case 'Contribution Overview':
        return this.displayCheck(objForChecking, node, menuParentName, false, true);
      case 'Account Details':
        // Disable Account details when entitiy is Organization
        if(this.checkOrganizationEntity()) return this.makeTheMenuDisabled(node, '');
        return this.displayCheck(objForChecking, node, menuParentName, false, true);
      
      default:
        return this.renderNavMenuItem(node, menuParentName);
    }
  }

  renderNavMenuItem(node, menuParentName) {
    return (
      <NavMenuItem key={node.name} className={node.className}>
        <a
          href='javascript:void(0)'
          onClick={() => {
            try {
              this.goToRoute(node.link, node.name, '', menuParentName);
            } catch (error) {
              recordError(error);
            }
          }}
        >
          {node.name}
        </a>
      </NavMenuItem>
    );
  }

  render() {
    const changeHeaderSelected = () => {
      if (this.props.location.pathname === '/open-an-additional-account/account-information/') {
        this.setState({ current: 'Open Additional Account' });
      }
    };

    let menuItems = menuConfig;
    getTokenInfo();
    
    const financialAdvisorFlag = JSON.parse(sessionStorage.getItem('userData'));
    if (
      (financialAdvisorFlag.financialAdvisorForAnyAccount &&
        this.props.location.pathname === '/financialadvisor') ||
      this.props.location.pathname === '/financialadvisor' || 
      (isGeminiUser() && financialAdvisorFlag.financialAdvisorForAnyAccount && this.props.location.pathname === '/csr/accountSummary' )
    ) {
      menuItems = faConfig;
    }

    // To load Menus only afer getting csr specific response - Only applicable in GDP
    const { navBarData } = this.props;
    menuItems = isGeminiUser() && !navBarData ? [] : menuItems;

    return (
      <NavContainer onLoad={changeHeaderSelected} data-test="navigation-container">
        <FixedWidth>
          <DisplayFlexContainer>
            <ImageContainer
              data-test="vc_logo_image"
              className='VC_logo'
              onClick={() => {
                try {
                  initiateTracking('headerLogo', 'Navigation', 'Global Header Navigation DP', 'VC Logo');
                  window.open(getpwUrl(), '_blank');
                } catch (error) {
                  recordError(error);
                }
              }}
            >
              <Img src={logo} alt='Vanguard Charitable logo' />
            </ImageContainer>

            <NavMenu
              onClick={this.handleClick}
              selectedKeys={[this.state.current]}
              mode='horizontal'
            >
              {menuItems.map((menu, i) =>
                this.renderNavigation(menu.name) && (
                  menu.childNode.length === 0 ? (
                    <MainPagesNavigation key={menu.name} disabled={isGeminiUser() && this.checkDisableMenuItemsForCSR(menu.name)} >
                        <a
                          href='javascript:void(0)'
                          onClick={() => {
                            try {
                              this.goToRoute(menu.link, menu.name);
                            } catch (error) {
                              recordError(error);
                            }
                          }}
                        >
                          {menu.name}
                        </a>
                    </MainPagesNavigation>
                  ) : (
                      <NavSubMenu
                        disabled={this.checkDisableMenuItemsForCSR(menu.name)}
                        className={ menu.name === 'CSR' ? 'coloring': '' }
                        key={menu.name}
                        popupClassName='menu-dd-overlay'
                        onTitleClick={
                          menu.link
                          ? this.changeHeaderSelection.bind(
                            this,
                            menu.childNode[menu.childNode.length - 1].name,
                            menu.link
                          ):function(){}
                        }
                        title={
                          <span className='submenu-title-wrapper'>
                            {menu.name}
                          </span>
                        }
                      >
                        { menu.childNode.map((node, i) => {
                          return menu.name !== 'CSR' ? this.checkingForDifferentSubMenu(node, menu.name) : this.populateCSRSubmenus(node)
                        })
                      }
                      </NavSubMenu>
                    )
                  )
              )}
            </NavMenu>

            <HamBurger>
              {this.state.isOpen ? (
                <img src={close} alt='close' onClick={this.openDrawer} />
              ) : (
                  <img
                    src={hamburger}
                    alt='hamburger'
                    onClick={this.openDrawer}
                  />
                )}
            </HamBurger>
          </DisplayFlexContainer>
        </FixedWidth>
        {/* Mobile View */}
        <NavInline
          mode='inline'
          isOpen={this.state.isOpen}
          selectedKeys={[this.state.current]}
        >
          {menuItems.map((menu, i) =>
            this.renderNavigation(menu.name) ? this.renderNavMenu(menu) : null
          )}
            {
              isGeminiUser() ? 
              <AssistanceContainer className='not-allowed-cursor'>
                Need Assistance?
              </AssistanceContainer> :
              <AssistanceContainer onClick={this.props.onDrawerClick}>
                Need Assistance?
              </AssistanceContainer>
            }
        </NavInline>
      </NavContainer>
    );
  }
}

PagesNav.propTypes = {
  accountID: PropTypes.any,
  accountRole: PropTypes.any,
  availableBalance: PropTypes.any,
  getAvailableBalance: PropTypes.func,
  grantAgreementFlag: PropTypes.any,
  navBarData: PropTypes.any,
  onDrawerClick: PropTypes.any,
  selectedHeader: PropTypes.func
}

const mapStateToProps = state => ({
  ...PagesNavDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  onDrawerClick: () => dispatch(showAssistanceComponent()),
  getAvailableBalance: data => dispatch(availableBalance(data)),
  selectedHeader: data => dispatch(selectHeader(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PagesNav);
